import React from 'react';

const TermsChanges: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">Updates to Terms</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Right to modify terms at any time</li>
        <li>Notice provided for material changes</li>
        <li>30-day notice for subscription changes</li>
        <li>Continued use implies acceptance</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Notification Process</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Email notification for registered users</li>
        <li>In-app notifications when applicable</li>
        <li>Website announcements for major changes</li>
        <li>Archive of previous versions maintained</li>
      </ul>

      <div className="bg-[#B3D9E6]/10 p-4 rounded-lg mt-6">
        <p className="text-sm text-gray-600">
          We encourage you to review these terms periodically. Your continued use of FeelHeard.me 
          after changes become effective constitutes your acceptance of the updated terms.
        </p>
      </div>
    </div>
  );
};

export default TermsChanges;